import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress } from "@mui/material";
export var ActionButton = function (_a) {
    var loading = _a.loading, onClick = _a.onClick, children = _a.children, disabled = _a.disabled, _b = _a.variant, variant = _b === void 0 ? "contained" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? true : _d;
    return (_jsxs(Button, { variant: variant, color: color, fullWidth: fullWidth, onClick: onClick, disabled: loading, sx: { position: "relative", borderRadius: "1rem" }, children: [children, loading && (_jsx(CircularProgress, { size: 24, sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                } }))] }));
};
